<mat-dialog-content>
  {{ text | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="yes()">
    {{ yesButtonText | translate }}
  </button>
  <button mat-button mat-dialog-close (click)="no()">
    {{ noButtonText | translate }}
  </button>
</mat-dialog-actions>
